import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { GLOBAL_CONSTANT } from "src/app/common/constant/global.constant";

@Component({
  selector: "app-search-by-general",
  templateUrl: "./general.component.html",
  styleUrls: ["./general.component.scss"],
})
export class GeneralComponent implements OnInit {
  searchFormModel: any; //IN_SearchByWild;
  errorFlag: boolean = false;
  educationTypes: any;

  @ContentChild("Template_CommonFiltersContainer", { static: false })
  commonFilterTemplate: TemplateRef<any>;
  @Input() commonFormFilterObject: any = {};
  @Input() commonFormFilterInputParams: any = {};
  @Output() onSearchTriChild = new EventEmitter();

  constructor() {
    this._init();
  }

  _triggerSearch() {
    let searchPayloadModel: any = {
      type: "BYNAME",
      filters: {}
    };
    let dd = {};
    if (this.searchFormModel.filters) {
      dd = JSON.parse(JSON.stringify(this.searchFormModel.filters));
    }
    let ddd = {};
    if (this.commonFormFilterObject) {
      ddd = JSON.parse(JSON.stringify(this.commonFormFilterObject));
    }

    searchPayloadModel.filters = { ...dd, ...ddd };
    if (searchPayloadModel.filters.boothName) {
      searchPayloadModel.filters.boothName =
        searchPayloadModel.filters.boothName.boothName;
    }
    searchPayloadModel = this._processLocalVariables(searchPayloadModel);

    this.onSearchTriChild.emit({
      data: JSON.parse(JSON.stringify(searchPayloadModel)),
    });
  }

  triggerSearch(voterSearchForm) {
    //form related activity or validation
    this._triggerSearch();
  }

  _processLocalVariables(searchPayloadModel) {
    if (searchPayloadModel.filters.education) {
      searchPayloadModel.filters.education =
        searchPayloadModel.filters.education.value;
    }
    return searchPayloadModel;
  }

  private _init() {
    this.educationTypes = GLOBAL_CONSTANT.EDUCATION_TYPE;
    this.searchFormModel = {
      type: "BYNAME",
      filters: {},
      page: {
        number: 0,
        size: 10,
      },
    };
  }

  clearModel() {
    this._init();
    this.errorFlag = false;
    this.onSearchTriChild.emit({
      actionMode:"RESET",
      data: JSON.parse(JSON.stringify(this.searchFormModel))
    });

  }

  ngOnInit() {
    this._init();
  }
}
